/**
 * @generated SignedSource<<7591886a04f76f13ca97ecb637b6f83c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_similarItems$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly browseUrl: string | null;
      readonly categoryCode: string | null;
      readonly categoryPath: string | null;
      readonly ecommerceTrackingParams: any | null;
      readonly serviceId: string | null;
      readonly title: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"FavoritesProvider_item" | "PdpRespSimilarItemCarousel_item">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "PdpRespSimilarItemsLanding_similarItems";
};
export type PdpRespSimilarItemsLanding_similarItems$key = {
  readonly " $data"?: PdpRespSimilarItemsLanding_similarItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_similarItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "moreLikeThisItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "browseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceTrackingParams",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemCarousel_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FavoritesProvider_item"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "moreLikeThisItemConnection",
  "abstractKey": null
};

(node as any).hash = "41cff2c9426e6752293e4feed92753cf";

export default node;
